var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftPagi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88066 8.46777L10.0607 5.28777C10.1304 5.21747 10.2133 5.16167 10.3047 5.1236C10.3961 5.08552 10.4941 5.06592 10.5932 5.06592C10.6922 5.06592 10.7902 5.08552 10.8816 5.1236C10.973 5.16167 11.0559 5.21747 11.1257 5.28777C11.2653 5.42829 11.3438 5.61838 11.3438 5.81652C11.3438 6.01466 11.2653 6.20474 11.1257 6.34527L8.47066 9.00027L11.1257 11.6553C11.2653 11.7958 11.3438 11.9859 11.3438 12.184C11.3437 12.3822 11.2653 12.5722 11.1257 12.7128C11.0556 12.7823 10.9725 12.8373 10.8811 12.8746C10.7897 12.9119 10.6919 12.9308 10.5932 12.9303C10.4945 12.9308 10.3966 12.9119 10.3052 12.8746C10.2138 12.8373 10.1307 12.7823 10.0607 12.7128L6.88066 9.53277C6.81036 9.46304 6.75456 9.38009 6.71649 9.2887C6.67841 9.1973 6.65881 9.09928 6.65881 9.00027C6.65881 8.90126 6.67841 8.80323 6.71649 8.71183C6.75456 8.62044 6.81036 8.53749 6.88066 8.46777Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPagi);
export default __webpack_public_path__ + "static/media/left_pagi.1aec1a047a7fb82e16725bd60b019a76.svg";
export { ForwardRef as ReactComponent };